import { render, staticRenderFns } from "./nine-year-part3.vue?vue&type=template&id=6688e9f6&scoped=true&"
import script from "./nine-year-part3.vue?vue&type=script&lang=js&"
export * from "./nine-year-part3.vue?vue&type=script&lang=js&"
import style0 from "./nine-year-part3.vue?vue&type=style&index=0&id=6688e9f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6688e9f6",
  null
  
)

export default component.exports